<template>
    <b-container fluid="true" class="h-100">
        <b-row no-gutters class="h-100">
            <b-col sm="12" md="6" lg="5" class="form-side">
                <b-img class="brand-logo-img img-responsive center-block"
                       :src="img.mntLogo"></b-img>

                <h3 class="form-signin-heading">{{ $t("login.welcome") }}</h3>
                <b-form class="form-signin" role="form">

                    {{ /*dev note: styles broken, so added those as custom*/ }}
                    <b-alert
                        :show="error" class="alert alert-danger mb-3"
                        dismissible fade @dismissed="error = false">
                        <span class="text-danger">{{ $t("login.error_login") }}</span>
                    </b-alert>

                    <b-alert
                        :show="redirectError" class="alert alert-danger mb-3"
                        fade
                    >
                        <span class="text-danger">{{ $t("login.error_redirect") }}</span>
                    </b-alert>

                    <b-form-group
                            id="input-group-1"
                            :label="$t('login.username')"
                            label-for="input-1"
                            label-align="left"
                    >
                        <b-form-input
                                id="input-1"
                                class="input"
                                v-model="username"
                                type="text"
                                required
                        ></b-form-input>
                    </b-form-group>


                    <b-form-group
                            id="input-group-2"
                            :label="$t('login.password')"
                            label-for="input-2"
                            label-align="left"
                    >
                        <b-form-input
                                id="input-2"
                                v-model="password"
                                type="password"
                                required
                        ></b-form-input>
                    </b-form-group>

                    <b-button
                        type="submit" variant="primary" class="btn btn-block text-uppercase"
                        @click.prevent="login"
                    >
                        {{ $t("login.sign_in") }}
                    </b-button>
                </b-form>
            </b-col>
            <b-col md="6" lg="7"  class="d-none d-md-block bg-image">
                <div class="bg-overlay"></div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {AUTH_REQUEST} from "../../store/actions/auth";
    import mntLogo from "../../assets/img/Montazhi_EAD_logo.svg";
    import {
        setDocumentTitle
    } from "../../utils/i18n/document";

    /**
     * Login page with user and password form.
     * Dispatches authentication request.
     * Has side image and logo.
     */

    export default {
        name: "Login",
        data() {
            return {
                username: "",
                password: "",
                img: {
                    mntLogo
                },
                error: false
            };
        },
        methods: {
            login: function () {
                const {username, password} = this;
                this.$store.dispatch(AUTH_REQUEST, {username, password})
                    .then(() => {
                        let redirectUrl = this.$route.query.redirect || "/dashboard";
                        this.$router.push(redirectUrl);
                    })
                    .catch(() => {
                        this.error = true;
                    });
            }
        },
        computed: {
            redirectError() {
                return !!this.$route.query.redirect;
            }
        },
        mounted() {
            setDocumentTitle(this.$t("login.title"))
        }
    };
</script>

<style scoped>
html, body {
    height: 100%;
    width: 100%;
}

.bg-image {
    /* The image used */
    background-image: url('../../assets/img/bg-homescreen.jpg');

    /* Full height */
    height: 100vh;

    /* Center and scale the image nicely */
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;

    padding: 0;
}

.bg-image::before {
	content: "";
	top: 0;
	left: 0;
	width: 2%;
	height: 100%;
	background: #fff;
	opacity: 1;
	position: absolute;
	z-index: 1;
	border-radius: 0 15px 15px 0;
}

.bg-overlay {
    /* background: transparent linear-gradient(239deg, #FFFFFF00 0%, #8781CA 100%) 0% 0% no-repeat border-box; */
    padding: 0;
    height: 100%;
    opacity: 0.54;
}

h3 {
    font-size: 24px;
    font-weight: 600;
}

/* ------------------ form side  ------------------------- */
.form-side {
    padding-top: 7%;
}

.brand-logo-img {
    display: block;
    margin: 8% auto;
    width: 323px;
    height: 70px;
}

.form-signin {
	min-width: 50%;
	padding: 15px;
	margin: 0 auto;
    max-width: 330px;
}

.form-signin-heading {
    padding-top: 4%;
    padding-bottom: 3%;
    text-align: center;
    font: 400 22px/30px Nunito,  sans-serif;
    letter-spacing: 0px;
    color: #232323;
    opacity: 1;
}

.form-signin label {
    text-align: left;
    font: 400 14px/40px Nunito,  sans-serif;
    letter-spacing: 0px;
    color: #232323;
    opacity: 1;
}

.form-signin input {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #BBBBBB;
    border-radius: 8px;
    opacity: 1;
    padding: 5px;
}

.btn.btn-block {
	background: #6299EB 0% 0% no-repeat padding-box;
	border-radius: 8px;
	opacity: 1;
    margin-top: 17%;
    padding: 5px;
    outline: 0 !important;
    font-weight: 600;
}

.btn.btn-block:hover {
    outline: 0 !important;
    -webkit-box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18),0 4px 15px 0 rgba(0,0,0,0.15);
    box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18),0 4px 15px 0 rgba(0,0,0,0.15);
    transition: 0.3s;
}

/*.alert {*/
/*	position: relative;*/
/*	padding: .75rem 1.25rem;*/
/*	padding-right: 1.25rem;*/
/*	margin-bottom: 1rem;*/
/*	border: 1px solid transparent;*/
/*	border-top-color: transparent;*/
/*	border-right-color: transparent;*/
/*	border-bottom-color: transparent;*/
/*	border-left-color: transparent;*/
/*	border-radius: .25rem;*/
/*}*/

/*.alert-danger {*/
/*    color: #721c24;*/
/*    background-color: #f8d7da;*/
/*    border-color: #f5c6cb;*/
/*}*/
</style>